/* Auto generated by gulp-typescript-template */

export const tipTemplate = `<div class="content-item -block  flex-layout"><svg class="item -content  svg-icon -xl  spacer-box -m-right"><use xlink:href="#lightbulb"/></svg><div class="item -grow  content-item-layout" js="content"></div></div>`;
